<script>
	import model from "../../stores/modelStore";
	import lookups from "../../stores/lookupStore";
	import { getTealiumID, registerPageComplete } from "../../tealium";
	import { projectSettings, referralTypes } from "../../config";
	import registrationTypes from "../../config/registrationTypes";
	import { isValid } from "../../validation";

	import Contact from "../../components/Contact.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Select from "../../components/Select.svelte";
	import YesNoGroup from "../../components/YesNoGroup.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import Claimant from "./components/Claimant.svelte";

	export let disabled = null;
	export let pageName = null;
	export let pageTitle = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let buttons = null;

	const handleSubmit = async (e) => {
		buttons.blockNext();

		$model.contact.emailAddressError = null;
		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				if (response && response.error === "IllegalContactEmailDomain") {
					$model.contact.emailAddressError = "Please provide a valid email address.";
				}
				console.log(response);
				//displayError(response);
			} else {
				await registerPageComplete(pageName, $model.contact.emailAddress, $model.contact.phoneNumber);

				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
	};

	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		$model.tealiumId = getTealiumID();
	}

	const initialise = () => {};

	initialise();
</script>

<PageSection>
	<Form {disabled} id="form-personal-details" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Please provide your Contact details</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<div class="confirmation-box-shadow">
			<Contact
				bind:firstName={$model.contact.firstName}
				bind:surname={$model.contact.surname}
				bind:emailAddress={$model.contact.emailAddress}
				emailAddressError={$model.contact.emailAddressError}
				bind:phoneNumber={$model.contact.phoneNumber}
				bind:address={$model.contact.address}
				bind:dateOfBirth={$model.contact.dateOfBirth}
				idPrefix="contact"
				required
				{disabled} />

			<FormRow>
				<FormColumn>
					<Select
						required
						{disabled}
						label="Who are you registering for?"
						id="regType"
						bind:value={$model.registrationType}
						optionList={registrationTypes.options}
						textProperty="name"
						valueProperty="value" />
				</FormColumn>
			</FormRow>
		</div>

		{#if $model.registrationType && $model.registrationType != registrationTypes.types.Myself.value}
			<div class="confirmation-box-shadow">
				<div class="claimant-details">
					<Claimant
						{disabled}
						registrationType={$model.registrationType}
						bind:claimant={$model.claimant}
						bind:executors={$model.executors}
						bind:contactIsExecutor={$model.contactIsExecutor}
						bind:relationshipToClaimant={$model.contact.relationshipToClaimant}
						contactFirstName={$model.contact.firstName}
						contactSurname={$model.contact.surname} />
				</div>
			</div>
		{/if}

		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn>
					<Select
						required
						{disabled}
						label="Where did you hear about our firm?"
						id="whereDidYouHear"
						bind:value={$model.whereDidYouHear}
						optionList={referralTypes}
						textProperty="name"
						valueProperty="name" />
				</FormColumn>
			</FormRow>
		</div>

		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn>
					<YesNoGroup
						required
						{disabled}
						name="willingToShareStory"
						label="Class actions can generate significant media interest. If media opportunities arise, are you willing to share your story with the press?"
						bind:value={$model.willingToShareStory} />
				</FormColumn>
			</FormRow>
		</div>

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<NavigationButtons bind:buttons />
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>

<style>
	.claimant-details {
		margin-bottom: 20px;
	}
</style>
